import { render, staticRenderFns } from "./ProfitabilityEvolutionTable.vue?vue&type=template&id=e9516844&scoped=true"
import script from "./ProfitabilityEvolutionTable.vue?vue&type=script&lang=js"
export * from "./ProfitabilityEvolutionTable.vue?vue&type=script&lang=js"
import style0 from "./ProfitabilityEvolutionTable.vue?vue&type=style&index=0&id=e9516844&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9516844",
  null
  
)

export default component.exports